var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 11,
    viewBox: "0 0 8 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 4.46143C0.5 6.88734 2.62224 8.89346 3.56159 9.66261C3.69603 9.77268 3.76406 9.82838 3.86435 9.85662C3.94245 9.87861 4.0574 9.87861 4.1355 9.85662C4.23598 9.82833 4.30353 9.77317 4.43848 9.66268C5.37783 8.89354 7.49996 6.88756 7.49996 4.46165C7.49996 3.54359 7.13123 2.66303 6.47485 2.01386C5.81848 1.3647 4.9283 1 4.00004 1C3.07178 1 2.1815 1.36475 1.52513 2.01392C0.868749 2.66308 0.5 3.54337 0.5 4.46143Z",
    stroke: "#1F284E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 4C3 4.55228 3.44772 5 4 5C4.55228 5 5 4.55228 5 4C5 3.44772 4.55228 3 4 3C3.44772 3 3 3.44772 3 4Z",
    stroke: "#1F284E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapPin);
export default __webpack_public_path__ + "static/media/map-pin.974198fe41d6627a163be8e3a84e6231.svg";
export { ForwardRef as ReactComponent };